import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@/i18n';
import { useLanguage } from '@/i18n/useLanguage';

// 見た目は元々 /lyrics と /liner-notes のページ内にあったピル型トグルをそのまま流用している
// （2026-08-15 にサイト全体で1つへ統合。ページ側の実装は撤去した）。

export default function LanguageToggle({ onChange }: { onChange?: () => void }) {
  const { t, i18n } = useTranslation();
  const lang = useLanguage();

  return (
    <div
      className="inline-flex p-0.5 rounded-full bg-background-100/80 border border-background-300/30"
      role="group"
      aria-label={t('lang.label')}
    >
      {SUPPORTED_LANGUAGES.map((code) => (
        <button
          key={code}
          onClick={() => {
            i18n.changeLanguage(code);
            onChange?.();
          }}
          aria-pressed={lang === code}
          className={`px-3 py-1 rounded-full text-xs tracking-wider whitespace-nowrap transition-all duration-300 cursor-pointer ${
            lang === code
              ? 'bg-primary-500 text-background-50'
              : 'text-foreground-600 hover:text-foreground-900'
          }`}
        >
          {t(`lang.${code}`)}
        </button>
      ))}
    </div>
  );
}
